module.exports = __webpack_public_path__ + "img/17.d8140c76.png";